import { type CTNCalendarProps } from '@ctn/ui/types/ctn-calendar';

const commonCalendar: Pick<CTNCalendarProps<any>, 'locale' | 'placeholder' | 'iconRight'> = {
	locale: 'es',
	placeholder: 'Seleccionar',
	iconRight: { icon: 'date', color: 'black-100' },
};

export { commonCalendar };
